import React from "react";
import {connect} from "dva";
import {Descriptions} from 'antd'
import {component_tool, framework_tool, utils_tool} from '@/tool';

import {operateTypeEnum, operateBizTypeEnum, statusEnum} from '../util'

import ReactJson from 'react-json-view'

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizSpin, WizCard} = component_tool
let {Session} = utils_tool

import './index.less'
class Index extends WizContainer {
  componentName = 'UserActionLogInfoDetail';

  constructor(props) {
    super(props);
    this.state = {}

    let {history} = this.props;
    if (history?.location?.record?.id) {
      this.initialValue = history?.location?.record?.id
      Session.set('UserActionLogInfoDetail', this.initialValue)
    } else {
      this.initialValue = Session.get('UserActionLogInfoDetail') || {}
    }
  }

  _componentDidMount() {
    if (this.initialValue) {
      this.doAction({
        path: "userActionLogInfo/getInfoById",
        payload: {
          key: "detail",
          apiParams: {
            id: this.initialValue,
          }
        }
      });
    }
  }

  propsAndStateOnChange = {
    detail: this._detail.bind(this),
  }

  _detail(nextProps, nextState) {
    let {success, data, msg} = nextProps?.detail

    if (success) {
      Object.keys(data).forEach(key => nextState[key] = data[key])
    } else {
      wizNotice.error(msg);
    }
    return !!success;
  }


  _render() {
    const {detailLoading = true} = this.props
    const {
      linkTraceId,
      fullName,
      operateType,
      operateBizType,
      operateBizName,
      status,
      ip,
      serviceName,
      method,
      header,
      body,
      result,
    } = this.state

    return (
      <div className={'user-action-log-info-detail'}>
        <WizSpin spinning={detailLoading}>
          <WizCard className={'basic-information'} title="基本信息">
            <Descriptions column={2}>
              <Descriptions.Item label="操作人">{fullName}</Descriptions.Item>
              <Descriptions.Item label="会话标识">{linkTraceId}</Descriptions.Item>
              <Descriptions.Item label="操作类型">{operateType && operateTypeEnum[operateType]}</Descriptions.Item>
              <Descriptions.Item label="业务类型">{operateBizType && operateBizTypeEnum[operateBizType]}</Descriptions.Item>
              <Descriptions.Item label="业务名称">{operateBizName}</Descriptions.Item>
              <Descriptions.Item label="请求状态">{status && statusEnum[status]}</Descriptions.Item>
              <Descriptions.Item label="请求ip">{ip}</Descriptions.Item>
            </Descriptions>
          </WizCard>
          <WizCard className={'operation-details'} title="操作详情">
            <Descriptions column={2}>
              <Descriptions.Item label="服务名">{serviceName}</Descriptions.Item>
              <Descriptions.Item label="请求类型">{method}</Descriptions.Item>

              <Descriptions.Item className={'ant-descriptions-item-data'} span={2} label="请求头">
                <ReactJson name={'header'} src={header && JSON.parse(header) || {}}/>
              </Descriptions.Item>
              <Descriptions.Item className={'ant-descriptions-item-data'} span={2} label="请求内容">
                <ReactJson name={'request'} src={body && JSON.parse(body) || {}}/>
              </Descriptions.Item>
              <Descriptions.Item className={'ant-descriptions-item-data'} span={2} label="响应结果">
                <ReactJson name={'response'} src={result && JSON.parse(result) || {}}/>
              </Descriptions.Item>
            </Descriptions>

          </WizCard>
        </WizSpin>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {userActionLogInfo} = state;

  const detail = modelUtils.getModelEntity(userActionLogInfo, 'detail');

  const load = modelUtils.getLoadingState(userActionLogInfo, ['detail']);

  return {
    detail,
    ...load,
  }
};

export default connect(mapStateToProps)(Index);
